
<template>
	<page>
		<module>
            <view-list ref="view" :work-type="workType" selector :view-config="saasInfo.viewmanage">
            <template #search>
					<m-search ref="search">
                        <m-search-item label="背贴码">
                            <m-code-batch-input name="produce_codes" field-name="背贴码" placeholder="请输入背贴码，支持批量"></m-code-batch-input>
                        </m-search-item>
                        <m-search-item label="IMEI">
                            <m-code-batch-input name="imeis" field-name="IMEI" placeholder="请输入IMEI，支持批量"></m-code-batch-input>
                        </m-search-item>
						<m-search-item label="订单号">
							<c-input name="keyword" placeholder="销售单号"></c-input>
						</m-search-item>
						<m-search-item label="产品信息">
							<c-input name="product_info" placeholder="产品名称/背贴码/IMEI"></c-input>
						</m-search-item>
						<m-search-item label="客户">
                            <c-select name="customer_id" async @search="searchCustomer"></c-select>
                        </m-search-item>
                        <m-search-item label="关联还款单">
                            <c-input name="record_no" placeholder=""></c-input>
                        </m-search-item>
                        <m-search-item label="下单时间" colspan="2">
							<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button v-if="auth('b_credit_bill_repayment')" color="main" prepend-icon="tf-batch" @click="createRepaymentOrder()">生成还款单</c-button>
				</template>

                <template #product_info="{data}">
                    <m-product-info :name="data.product_name || getProductText(data)" :level="data.level_type" :code="data.produce_code" :imei="data.imei"></m-product-info>
                </template>

				<template #cost_price="{data}">
					{{formatPrice(data.cost_price)}}
				</template>

				<template #produce_code="{data}">
					{{data.produce_code}} <c-link color="gray" @click="$copy(data.produce_code)"><i class="tf">&#xe6b0;</i></c-link>
				</template>

				<template #produce_imei="{data}">
					{{data.imei}} <c-link v-if="data.imei" color="gray" @click="$copy(data.imei)"><i class="tf">&#xe6b0;</i></c-link>
				</template>

				<template #sale_price="{data}">
					<span style="color: green;">{{formatPrice(data.sale_price)}}</span>
				</template>

				<template #after_sale_amount="{data}">
					<span style="color: #e53e3e;">{{formatPrice(data.after_sale_amount)}}</span>
				</template>

				<template #debt_amount="{data}">
					<span style="color:brown;" v-if="data.credit_bill_state != 3">{{formatPrice(data.debt_amount)}}</span>
					<span v-else>-</span>
				</template>
                <!--账单状态-->
				<template #credit_bill_state="{data}">
                    <c-state async dict="CREDIT_BILL_STATE" tag :value="data.credit_bill_state"></c-state>
                </template>

				<template #receiver_info="{data}">
					<div class="m-product-info">
						<p v-if="data.receiver_name">{{data.receiver_name}}　{{data.receiver_phone}}</p>
						<p v-if="data.receiver_address" class="m-product-info-code">{{data.receiver_address}}</p>
						<p v-if="!data.receiver_name && !data.receiver_address">-</p>
					</div>
				</template>

				<template #sell_type="{data}">
					<c-state async dict="SALE_SELL_TYPE" tag :value="data.sell_type"></c-state>
				</template>

				<template #create_user_id="{data}">
					{{data.create_user_realname || '-'}}
				</template>
                <!--关联还款单-->
                <template #repayment_order="{data}">
                    <c-link v-if="auth('b_credit_repayment_view') && data.repayment_order" color="blue" @click="creditRepaymentDetail(data)">
                        {{data.repayment_order}}
                    </c-link>
                    <span v-else-if="data.repayment_order">{{data.repayment_order}}</span>
                    <span v-else>{{data.repayment_order}}</span>
                </template>
			</view-list>

            <!--生成还款单弹窗-->
            <c-dialog ref="dialog" title="生成还款单" width="500" @resolve="handleCreateRepaymentOrder">
                <c-form ref="form" unit-width="100%">
                    <c-form-item label="还款订单数">
                        <c-input name="order_count" disabled></c-input>
                    </c-form-item>
                    <c-form-item label="还款总金额">
                        <c-input name="repayment_amount" disabled></c-input>
                    </c-form-item>
                    <c-form-item label="备注">
                        <c-input type="textarea" name="remark" maxlength="500" placeholder="请输入信息信息"></c-input>
                    </c-form-item>
                </c-form>
            </c-dialog>
		</module>
	</page>
</template>

<script>
	import {mapState} from "vuex";
    import {asyncMapState} from '@/store'

    export default {
		data() {
            return {
                workType: 122,
                orderIds: [],
                repayment_amount:0,
                customer_id:0
            }
		},
        computed: {
            // 获取dictName选项数据
            ...mapState(['saasInfo']),
            ...asyncMapState(['SALE_SELL_TYPE'])
        },
		methods: {
			/*********搜索客户**********/
			searchCustomer(keyword, resolve) {
				this.request({
					url: '/sale/customer/options',
					data: {
						keyword: keyword
					},
					success: data => {
						resolve((data || []).map(item => {
							return {
								name: item.customer_name,
								value: item.id
							};
						}));
					}
				});
			},

			/*********格式化价格**********/
			formatPrice(price) {
				if (price === null || price === undefined || price === '') return '-';
				return '¥' + parseFloat(price).toFixed(2);
			},

			/*********获取产品信息文字**********/
			getProductText(data) {
				var parts = [];
				if (data.brand_name) parts.push(data.brand_name);
				if (data.model_name) parts.push(data.model_name);
				if (data.memory_name) parts.push(data.memory_name);
				if (data.color_name) parts.push(data.color_name);
				return parts.join(' ') || '-';
			},

            //检验参数
            validateCustomer(list) {
                // 取第一个作为基准值
                this.customer_id = list[0].customer_id;
                const validList = list;
                if (validList.length <= 1) {
                    return true;
                }
                // 只要有任意一个和基准不一样，校验失败
                const hasDiff = validList.some(item => {
                    return item.customer_id !== this.customer_id;
                });

                if (hasDiff) {
                    return false;
                }
                return true;
            },

			/*********生成还款单（单个/批量）**********/
			createRepaymentOrder(selectedRows) {
                this.orderIds = [];
                this.repayment_amount = 0;
                this.customer_id = 0;
				var rows = [];
				if (selectedRows && selectedRows.order_id) {
					// 单个订单收款
					rows = [selectedRows];
				} else {
					// 批量收款：获取选中的行（参照线上订单批量生成发货单写法）
					rows = (selectedRows || []).map(item => item.data || item);
					if (!rows.length) {
						var listRef = this.$refs.view && this.$refs.view.$refs.list;
						rows = (listRef && listRef.getRow('selected') || []).map(item => item.data || item);
					}
				}

				if (!rows.length) {
					this.$message({message: '请先选择订单', type: 'warn'});
					return;
				}

				// 仅待付款订单可收款
				rows = rows.filter(item => item.credit_bill_state == 1);
				if (!rows.length) {
					this.$message({message: '请选择“待还款”状态的订单进行操作', type: 'warn'});
					return;
				}
                if (!this.validateCustomer(rows)){
                    this.$message({
                        message: '只能请选择同一个客户的订单进行还款操作',  // 提示内容,
                        type: 'warn'
                    });
                    return;
                }
				this.orderIds = rows.map(item => item.order_id);
                this.repayment_amount = rows.reduce((acc, item) => {
                    const sale = Number(item.sale_price || 0)
                    const after = Number(item.after_sale_amount || 0)
                    return acc + sale - after
                }, 0);
                this.$refs.form.set({
                    customer_id:this.customer_id,
                    order_count:this.orderIds.length,
                    repayment_amount: this.formatPrice(this.repayment_amount)
                });
                this.$refs.dialog.open();
			},

            /******提交跟进记录*******/
            handleCreateRepaymentOrder(stop, next) {
                stop();
                this.$refs.form.submit({
                    url: '/order/credit/repayment/create',
                    rule: {},
                    dataFormatter: (data) => {
                        data.order_ids = this.orderIds;
                        data.customer_id = this.customer_id;
                        data.repayment_amount = this.repayment_amount;
                        return data;
                    },
                    success: () => {
                        next();
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                        this.$refs.view.update();
                    }
                });
            },
            //打开还款单详情页
            creditRepaymentDetail(data){//打开模板选择弹窗
                this.globalDialog('creditRepaymentDetail', {
                    props: {
                        id: data.repayment_id
                    }
                }, this.$refs.view.update);
            }
		}
	}
</script>

<style lang="stylus" scoped>
	.m-product-info {
		line-height: 24px;
		font-size: 13px;
		color: #333;

		.m-product-info-name {
			display: flex;
			align-items: center;
			gap: 4px;
		}

		.m-product-info-code {
			color: #999;
			font-size: 12px;
		}
	}
</style>
